import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import React from "react";
import { useTranslation } from "react-i18next";
import { trHeader } from "../i18n/headerMap";

export default function Locking(props) {
  const { t } = useTranslation();

  function setChosenColumn(column) {
    var columnObj = props.column;
    columnObj.connection = column.Name;
    columnObj.database = column.Database;
    props.onChosen(columnObj);
  }

  return (
    <div>
      <Popup
        className="wms-import-popup"
        position="center center"
        modal
        closeOnDocumentClick
        open={props.isOpen}
        onClose={props.onClose}
      >
        <div className="outer wms-import-popup-panel">
          <div
            className="header wms-import-popup-header"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2em",
            }}
          >
            <h4>
              {t("import.linkingTitle", { col: props.column?.Header ?? "" })}
            </h4>
          </div>

          <div className="choices wms-import-locking-grid">
            {props.columns.map((column) => (
              <button
                key={column.Name}
                className="actions smallerr lock"
                onClick={() => setChosenColumn(column)}
              >
                <div className="shortened-lock">
                  {column.required ? column.Name + " (*)" : column.Name}
                </div>
                <div className="smaller-friendly">
                  {typeof column.friendly === "string"
                    ? trHeader(column.friendly, t)
                    : column.friendly}
                </div>
              </button>
            ))}
          </div>
        </div>
      </Popup>
    </div>
  );
}
